import { DiscountAPI } from "@/api/discount";
import websocket from "@/websocket";
import { MasterDiscountMutationHandler } from "./mutationHandler";

export const MasterDiscountsService = {
  async createDiscount(data) {
    const { data: discount } = await DiscountAPI.create(data);
    websocket.execIfNotConnected(() => {
      MasterDiscountMutationHandler.discountCreated({ discount });
    });
    return discount;
  },
  async updateDiscount(id, data) {
    const { data: discount } = await DiscountAPI.updateById(id, data);
    websocket.execIfNotConnected(() => {
      MasterDiscountMutationHandler.discountUpdated({
        updated_discount: discount,
      });
    });
    return discount;
  },
  async removeDiscount(id) {
    const { discount } = await DiscountAPI.deleteById(id);
    websocket.execIfNotConnected(() => {
      MasterDiscountMutationHandler.discountRemoved({ discount });
    });
    return discount;
  },
};
